import * as React from 'react';

import {colors} from '../../../colors/colors';
import {getColorNameFromTagColor} from '../../../colors/helpers';
import {Popover} from '../../../popover/popover';

import {TokenizedItemWrapper} from './tokenized-item-wrapper';

import styles from './truncated-items.module.css';

type Props = {
    renderRow: (value: any) => React.ReactNode | string;
    isTokenized: boolean;
    value: any[];
};

TruncatedItems.defaultProps = {
    isTokenized: true,
};

export function TruncatedItems(props: Props) {
    const [isShowingMoreEntities, setShowingMoreEntities] = React.useState<boolean>(false);
    const showMoreRef = React.useRef(null);

    const handleMouseOver = () => {
        setShowingMoreEntities(true);
    };

    const handleMouseOut = () => {
        setShowingMoreEntities(false);
    };

    if (props.value.length <= 2) {
        return props.value.map<React.ReactNode>((row, index) =>
            props.isTokenized ? (
                <TokenizedItemWrapper
                    key={index}
                    colorName={row.color ? getColorNameFromTagColor(row.color) : undefined}
                >
                    {props.renderRow(row)}
                </TokenizedItemWrapper>
            ) : (
                props.renderRow(row)
            )
        );
    }

    const firstRow = props.isTokenized ? (
        <TokenizedItemWrapper
            colorName={
                props.value[0] && props.value[0].color
                    ? getColorNameFromTagColor(props.value[0].color)
                    : undefined
            }
        >
            {props.renderRow(props.value[0])}
        </TokenizedItemWrapper>
    ) : (
        props.renderRow(props.value[0])
    );

    return (
        <div>
            {firstRow}
            <div
                className={props.isTokenized ? styles['show-more--tokenized'] : styles['show-more']}
            >
                <span onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} ref={showMoreRef}>
                    and {props.value.length - 1} more…
                </span>
            </div>
            {isShowingMoreEntities ? (
                <Popover anchor={showMoreRef.current}>
                    <ul className={styles['truncated-list']}>
                        {props.value.slice(1).map((row, index) => (
                            <div
                                key={index}
                                style={{
                                    backgroundColor: colors[getColorNameFromTagColor(row.color)],
                                }}
                                className={row.color ? styles['color-named-value'] : undefined}
                            >
                                {props.renderRow(row)}
                            </div>
                        ))}
                    </ul>
                </Popover>
            ) : undefined}
        </div>
    );
}
